




import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const commonModule = namespace("common");

@Component({
  components: {}
})
export default class Index extends Vue {
  @commonModule.Mutation("SAVE_NAV_TITLE") saveNavTitle: any;

  content = "";

  created() {
    this._getHelpDetail();
  }

  _getHelpDetail() {
    const { id } = this.$route.params;
    (this as any).$apis
      .getHelpDetail({
        id
      })
      .then(res => {
        const { content, title } = res;
        this.content = content;
        document.title = title;
        this.saveNavTitle(title);
      })
      .catch(e => {
        
      });
  }
}
